import React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import Img from "gatsby-image"
import 'bootstrap/dist/css/bootstrap.css';
import {
	Container,
  Row,
  Col
  } from "reactstrap";
import Call from '../../images/call.png';
import Location from '../../images/location.png';
import Clock from '../../images/clock.png';
import Mail from '../../images/mail.png';
import AniLink from "gatsby-plugin-transition-link/AniLink"

const ContactInfo = () => (
  <StaticQuery
    query={graphql`
      query ContactInfo {
  allContentfulContactPage {
    edges {
      node {
        address
        email
        openingHours
        phone
      }
    }
  }
}

        `}
render={data => (
<div>
  <section>
    <Container>
					{data.allContentfulContactPage.edges.map(({ node }) => (
      <Row>

        <Col lg="3">
          <div className="info-box">
            <img src={Call} />
            <h2>Phone</h2>
            <p>{node.phone}</p>
          </div>
        </Col>
        <Col lg="3">
          <div className="info-box">
            <img src={Location} />
            <h2>Address</h2>
            <p>{node.address}</p>
          </div>
        </Col>
        <Col lg="3">
          <div className="info-box">
            <img src={Clock} />
            <h2>Opening Hours</h2>
            <p>{node.openingHours}</p>
          </div>
        </Col>
        <Col lg="3">
          <div className="info-box">
            <img src={Mail} />
            <h2>Email</h2>
            <p>{node.email}</p>
          </div>
        </Col>

      </Row>
		))}
    </Container>
  </section>
</div>
)}
  />
);

export default ContactInfo;
